import * as React from 'react';
import { SVGProps } from 'react';

const SvgMaximizeHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
    <path
      d="M9.10742 12.3516L6.45577 15.0032L9.10742 17.6549"
      stroke="#1E0036"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8926 17.6549L23.5442 15.0032L20.8926 12.3516"
      stroke="#1E0036"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75016 14.9998L22.9373 14.9998"
      stroke="#1E0036"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.2498 14.9998L17.0627 14.9998"
      stroke="#1E0036"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgMaximizeHorizontal;
